import {useState} from "@hookstate/core";
import {Button, ButtonGroup, Form, InputGroup, Table} from "react-bootstrap";

import './Calculator.scss'

function Calculator() {
    const bleed = useState(.125);
    const bleedOther = useState(0);
    const bleedSelected = useState(0);
    const bleedOtherDisable = useState(true);

    const safetyBorder = useState(true);

    const jobSize = useState({x: 3.5, y: 2});
    const quantity = useState(500);

    const customPageSize = useState({x: 19, y: 25});


    function onBleedChange(value) {
        bleedSelected.set(value);

        switch (value) {
            case 0: bleed.set(.125);
            break;
            case 1: bleed.set(0);
            break;
            case 2: bleed.set(bleedOther.get());
            break;

            default: bleed.set(.125);
        }

        bleedOtherDisable.set(value !== 2);
    }

    function calculateImpose(pageSize) {
        if (safetyBorder.get()) {
            pageSize.x -= .125;
            pageSize.y -= .125;
        }

        const jobX = jobSize.get().x + bleed.get();
        const jobY = jobSize.get().y + bleed.get();

        let x = Math.floor(pageSize.x / jobX);
        let y = Math.floor(pageSize.y / jobY);
        const portrait = x*y;

        x = Math.floor(pageSize.y / jobX);
        y = Math.floor(pageSize.x / jobY);
        const landscape = x*y;

        return portrait > landscape ? portrait : landscape;
    }

    function calculateSheetsReq(imposed, quantity) {
        return Math.ceil(quantity / imposed);
    }

    function tableRow(pageSizeX, pageSizeY) {
        if (pageSizeX !== 0 && pageSizeY !== 0) {
            const imposed = calculateImpose({x: pageSizeX, y: pageSizeY});

            return <tr>
                <td>{pageSizeX}x{pageSizeY}</td>
                <td>{imposed}</td>
                <td>{calculateSheetsReq(imposed, quantity.get())}</td>
            </tr>;
        } else {
            const imposed = calculateImpose({x: customPageSize.get().x, y: customPageSize.get().y});

            return <tr>
                <td id={'customSize'}>
                    <div className={'sizeBoxes'}>
                        <InputGroup>
                            <InputGroup.Text>X"</InputGroup.Text>
                            <Form.Control id={'customPageSizeX'}
                                          type={'number'}
                                          value={customPageSize.x.get()}
                                          onChange={(e) => customPageSize.x.set(Number(e.target.value))}>
                            </Form.Control>
                        </InputGroup>
                        <b className={'multiplyInd'}>&times;</b>
                        <InputGroup>
                            <InputGroup.Text>Y"</InputGroup.Text>
                            <Form.Control id={'customPageSizeY'}
                                          type={'number'}
                                          value={customPageSize.y.get()}
                                          onChange={(e) => customPageSize.y.set(Number(e.target.value))}>
                            </Form.Control>
                        </InputGroup>
                    </div>
                </td>
                <td>{imposed}</td>
                <td>{calculateSheetsReq(imposed, quantity.get())}</td>
            </tr>
        }
    }


    function bleedDiv() {
        return <div id={'bleedDiv'}>
            <p>Bleed: </p>
            <ButtonGroup>
                <Button onClick={_ => onBleedChange(0)}
                        variant={bleedSelected.get() === 0 ? "primary" : "secondary"}>
                    0.125"
                </Button>
                <Button onClick={_ => onBleedChange(1)}
                        variant={bleedSelected.get() === 1 ? "primary" : "secondary"}>
                    0"
                </Button>
                <Button onClick={_ => onBleedChange(2)}
                        variant={bleedSelected.get() === 2 ? "primary" : "secondary"}>
                    Other
                </Button>
                <Form.Control id={'bleedOther'} disabled={bleedOtherDisable.get()}
                              type={'number'}
                              value={bleedOther.get()}
                              onChange={e => {
                                  bleedOther.set(Number(e.target.value));
                                  bleed.set(Number(e.target.value));
                              }}
                />
            </ButtonGroup>

            <Form.Check id={'safetyBorder'} label={"Safety Border (.125\" Around Page)"}
                        checked={safetyBorder.get()}
                        onChange={e => safetyBorder.set(e.target.checked)}
            />
        </div>;
    }

    function jobSizeDiv() {
        return <div id={'jobSizeDiv'} className={'sizeBoxes'}>
            <p>Job size:</p>
            <InputGroup>
                <InputGroup.Text>X"</InputGroup.Text>
                <Form.Control id={'jobSizeX'}
                              type={'number'}
                              value={jobSize.x.get()}
                              onChange={(e) => jobSize.x.set(Number(e.target.value))}>
                </Form.Control>
            </InputGroup>
            <b className={'multiplyInd'}>&times;</b>
            <InputGroup>
                <InputGroup.Text>Y"</InputGroup.Text>
                <Form.Control id={'jobSizeY'}
                              type={'number'}
                              value={jobSize.y.get()}
                              onChange={(e) => jobSize.y.set(Number(e.target.value))}>
                </Form.Control>
            </InputGroup>

            <p id={'quantityP'}>Quantity: </p>
            <Form.Control id={'quantity'} type={'number'}
                          value={quantity.get()}
                          onChange={e => quantity.set(Number(e.target.value))}
            />
        </div>
    }

    function resultsDiv() {
        return <div id={'resultsDiv'}>
            <Table>
                <thead>
                    <tr>
                        <th>Page Size</th>
                        <th>n-up</th>
                        <th>Pages needed</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRow(12,18)}
                    {tableRow(13,19)}
                    {tableRow(0,0)}
                </tbody>
            </Table>
        </div>
    }



    return <div id={'calculator'}>
        <h3>Imposition Calculator</h3><br/>
        {bleedDiv()}
        {jobSizeDiv()}
        {resultsDiv()}
    </div>
}

export default Calculator;